import React from "react";

import { useParams } from "react-router-dom";

import Page from "../../components/Page/Page";

export const CarPage: React.FC = () => {
  const { id } = useParams();
  console.log(id);
  return (
    <Page name="PageDetail" back>
      <h1>Detalhe de um veiculo!</h1>
    </Page>
  );
};
